import React, { useCallback, useState } from 'react'
import { useIntl } from 'react-intl'
import Image from 'components/Common/Image'
import Table from 'LuxKit/Tables/Table'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import FilterChip from 'LuxKit/Chips/FilterChip'
import TableHeader from 'LuxKit/Tables/TableHeader'
import TableHeaderCell from 'LuxKit/Tables/TableHeaderCell'
import TableBody from 'LuxKit/Tables/TableBody'
import TableBodyRow from 'LuxKit/Tables/TableBodyRow'
import TableBodyCell from 'LuxKit/Tables/TableBodyCell'
import TableHeaderRow from 'LuxKit/Tables/TableHeaderRow'
import HorizontalContainerWithFadedOverflow from 'components/Common/HorizontalContainerWithFadedOverflow'

interface Props {
  sizeChart: App.MerchandiseOfferSizing
}

function MerchandiseOfferSizeChart(props: Props) {
  const intl = useIntl()
  const { sizeChart } = props
  const [activeChart, setActiveChart] = useState<App.MerchandiseOfferSizeChart | undefined>(sizeChart.charts?.[0])

  const onChartSelect = useCallback<React.MouseEventHandler<HTMLButtonElement>>((event) => {
    const chart = sizeChart.charts?.find(chart => chart.name === event.currentTarget.dataset.id)
    if (chart) {
      setActiveChart(chart)
    }
  }, [sizeChart.charts])

  if (sizeChart.image) {
    return <Image
      image={sizeChart.image}
      alt={intl.formatMessage({
        id: '65wLwUv5kV',
        defaultMessage: 'Size chart',
        description: 'Alt text for merchandise size chart image',
      })}
    />
  } else if (sizeChart.charts) {
    return <VerticalSpacer gap={20}>
      <HorizontalContainerWithFadedOverflow gap={8}>
        {sizeChart.charts.map(chart => <FilterChip
          key={chart.name}
          data-id={chart.name}
          size="small"
          onClick={onChartSelect}
          selected={activeChart?.name === chart.name}
        >
          {chart.name}
        </FilterChip>)}
      </HorizontalContainerWithFadedOverflow>
      {activeChart && <Table>
        <TableHeader>
          <TableHeaderRow>
            {activeChart.headings.map(heading => <TableHeaderCell key={heading}>{heading}</TableHeaderCell>)}
          </TableHeaderRow>
        </TableHeader>
        <TableBody>
          {activeChart.rows.map((row, index) => <TableBodyRow key={index}>
            {row.map((cell, index) => <TableBodyCell key={index}>{cell}</TableBodyCell>)}
          </TableBodyRow>)}
        </TableBody>
      </Table>}
    </VerticalSpacer>
  }
}

export default MerchandiseOfferSizeChart
